import { combineReducers } from "@reduxjs/toolkit";
import { cartreducer } from "./Reducer";

const rootred = combineReducers({
  cartreducer,
});

export default rootred;
